import React from "react";
import Event1 from "../../assets/about-us/aboutus-hero1.png";
import Event2 from "../../assets/about-us/aboutus-hero2.png";
import HeroBg from "../../assets/about-us/about-hero.png";

const Hero = () => {
  return (
    <section
      className="bg-cover bg-center bg-no-repeat pb-12 pt-10 sm:pb-16 sm:pt-14 lg:pb-20 lg:pt-16 xl:pb-24"
      style={{ backgroundImage: `url(${HeroBg})` }}
    >
      <div className="px-4 sm:px-6 lg:px-8">
        <div className="mx-auto flex w-full max-w-[1725px] flex-col items-center gap-8 lg:flex-row lg:items-center lg:justify-between lg:gap-4">
          <div className="w-full max-w-[915px]">
            <span className="inline-block bg-[#923D8C] px-4 py-2 text-2xl font-bold leading-tight text-white sm:px-5 sm:py-2.5 sm:text-3xl lg:px-6 lg:py-3 lg:text-4xl xl:text-5xl xl:leading-[56px]">
              About us
            </span>

            <div className="bg-white px-5 py-8 shadow-[0_4px_20px_0_rgba(0,0,0,0.06)] sm:px-8 sm:py-10 lg:px-11 lg:py-12">
              <p className="text-base leading-7 text-black sm:text-lg lg:text-xl">
                <span className="font-bold">STEAM Minds</span> is an innovative
                EdTech company that provides AI-powered personalized,
                interactive, simulative and adaptive gamified learning
                experiences.
              </p>

              <p className="mt-4 text-base leading-7 text-black sm:mt-6 sm:text-lg lg:text-xl">
                The company offers <span className="font-bold">STEAM</span>
                solutions for k12 through the use of advanced technology,
                including virtual, augmented, and mixed realities based web
                applications.
              </p>
            </div>
          </div>

          <div className="relative hidden h-[360px] w-full max-w-[500px] border-2 border-[#FF6636] lg:block xl:h-[489px] xl:max-w-[621px]">
            <img
              src={Event1}
              alt="Students learning in lab"
              className="absolute -bottom-0.5 -left-1 h-[220px] w-[200px] object-cover xl:h-[317px] xl:w-[280px]"
            />
            <img
              src={Event2}
              alt="Students in classroom"
              className="absolute -bottom-0.5 -right-0.5 h-[300px] w-[230px] object-cover xl:h-[441px] xl:w-[339px]"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
